import { createStyles } from 'antd-style';

import { ThemeColors, ThemeSpaces } from '../theme';
import { absolute } from '../styles/mixins';

export const useDetailPageStyles = createStyles(({ token }) => ({
  root: {
    ...absolute(),
    backgroundColor: ThemeColors.COLOR_WHITE3,
  },
  content: {
    width: '100%',
    height: '100%',
    minWidth: token.screenXSMin,
    display: 'flex',
    flexDirection: 'column',
    padding: ThemeSpaces.SPACE_NORM,
  },
  innerContent: {
    flex: 1,
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    margin: `${ThemeSpaces.SPACE_NORM_20}px ${ThemeSpaces.SPACE_NORM}px`,

    [`@media (max-width: ${token.screenMDMax}px)`]: {
      margin: `${ThemeSpaces.SPACE_NORM_20}px 0`,
    },
  },
}));
